import { memo, useContext } from "react";
import { SettingsContext } from "../contexts/settings";

/** Render before `PortalCustomizationStyleTag` so its `:root` variables win; never set these inline. */
export const LegacyThemeStyleTag = memo(function LegacyThemeStyleTag({
  apply,
}: {
  apply: boolean;
}) {
  const theme = useContext(SettingsContext)?.theme;

  // Empty strings are omitted so stylesheet defaults still apply.
  const value = (setting: string | null | undefined) =>
    apply ? (setting ?? "inherit") : "inherit";
  const line = (variable: string, setting: string | null | undefined) =>
    value(setting) === "" ? "" : `${variable}: ${value(setting)};`;

  return (
    <style>{`:root {
      ${line("--redo-primary-color", theme?.button_background_color)}
      ${line("--redo-primary-button-color", theme?.button_background_color)}
      ${line("--redo-text-color", theme?.button_text_color)}
      ${line("--redo-accent-color", theme?.accent_color)}
      ${line("--redo-accent-color-background", theme?.accent_background_color)}
      ${line("--return-app-body-font-family", theme?.body_font_family)}
      ${line("--return-app-title-font-family", theme?.title_font_family)}
    }`}</style>
  );
});
